import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Store } from "@ngxs/store";
import { map } from "rxjs/operators";
import { ELibraryModel } from "src/app/shared/interfaces/e-library";

import {
  GET_DASHBOARD_ANOUNCEMENTS,
  GET_ELIBRARY_ALL_FOLERS_AND_CONTENT,
  GET_ELIBRARY_CONTENT_BY_ID,
  GET_ELIBRARY_INITIAL_DISPLAY,
  GET_FILTER_LOV,
  GET_RECENT_UPLOAD,
  GET_SINGLE_PRODUCT_DETAILS,
  RESET_ANNOUNCEMENT_SELECTED,
  RESET_ELIBRARY_CONTENT_AND_RECENT_UPLOAD,
  RESET_SEARCH_ELIBRARY_CONTENT,
  RESET_SELECTED_PRODUCT_DETAIL,
  SEARCH_ELIBRARY_CONTENT,
  SET_PRODUCT_BREADCRUM,
  SET_SELECTED_ANNOUNCEMENT,
  SET_SELECTED_PRODUCT_DETAIL,
} from "./e-library.action";
import { ELibraryService } from "./e-library.service";

@State<ELibraryModel>({
  name: "ELibraryState",
  defaults: {
    folderContent: null,
    eLibraryContent: null,
    selectedProductDetail: {
      productDetail: null,
      productPath: null,
    },
    selectedAnnouncement: null,
    productBreadCrum: null,
    dashboardAnnouncements: null,
    searchedELibrary: {
      data: null,
      error: false,
    },
    recentUpload: null,
    filterLOV: null,
  },
})
@Injectable()
export class ELibraryState {
  constructor(
    private readonly eLibraryService: ELibraryService,
    private readonly store: Store,
  ) {}

  @Selector()
  public static filterLOV(state: ELibraryModel) {
    return state?.filterLOV ? state.filterLOV : [];
  }

  @Selector()
  public static eLibraryContent(state: ELibraryModel) {
    return state?.eLibraryContent ? state.eLibraryContent.folders : [];
  }

  @Selector()
  public static folderContent(state: ELibraryModel) {
    return state?.folderContent ? state.folderContent.contents : [];
  }

  @Selector()
  public static selectedProductDetail(state: ELibraryModel) {
    return state?.selectedProductDetail ? state.selectedProductDetail : null;
  }

  @Selector()
  public static dashboardAnnouncement(state: ELibraryModel) {
    return state?.dashboardAnnouncements ? state.dashboardAnnouncements : null;
  }

  @Selector()
  public static searchedELibrary(state: ELibraryModel) {
    return state?.searchedELibrary ? state.searchedELibrary : null;
  }

  @Selector()
  public static recentUpload(state: ELibraryModel) {
    return state?.recentUpload ? state.recentUpload : null;
  }

  @Selector()
  public static selectedAnnouncement(state: ELibraryModel) {
    return state?.selectedAnnouncement ? state.selectedAnnouncement : null;
  }

  @Selector()
  public static productBreadCrum(state: ELibraryModel) {
    return state?.productBreadCrum ? state.productBreadCrum : null;
  }

  @Action(GET_FILTER_LOV)
  public getFilterLOV(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_FILTER_LOV,
  ) {
    return this.eLibraryService.getFilterLOV(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            filterLOV: res,
          });
        }
      }),
    );
  }

  @Action(GET_ELIBRARY_ALL_FOLERS_AND_CONTENT)
  public getAllELibraryFolderAndContent(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_ELIBRARY_ALL_FOLERS_AND_CONTENT,
  ) {
    return this.patchStructuredFolderContent(patchState, payload);
  }

  @Action(GET_DASHBOARD_ANOUNCEMENTS)
  public getDashboardAnnouncements(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_DASHBOARD_ANOUNCEMENTS,
  ) {
    return this.eLibraryService.getELibraryContent(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            dashboardAnnouncements: res,
          });
        }
      }),
    );
  }

  @Action(SET_SELECTED_ANNOUNCEMENT)
  public setSelectedAnnouncement(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: SET_SELECTED_ANNOUNCEMENT,
  ) {
    patchState({
      selectedAnnouncement: payload,
    });
  }

  @Action(RESET_ANNOUNCEMENT_SELECTED)
  public resetNotificationList(
    { patchState }: StateContext<ELibraryModel>,
    _action: RESET_ANNOUNCEMENT_SELECTED,
  ) {
    patchState({
      selectedAnnouncement: null,
    });
  }

  @Action(SET_SELECTED_PRODUCT_DETAIL)
  public setSelectedProductDetail(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: SET_SELECTED_PRODUCT_DETAIL,
  ) {
    patchState({
      selectedProductDetail: {
        productDetail: payload.productDetail,
        productPath: payload.productPath,
      },
    });
  }

  @Action(RESET_SELECTED_PRODUCT_DETAIL)
  public resetSelectedProductDetail(
    { patchState }: StateContext<ELibraryModel>,
    _action: RESET_SELECTED_PRODUCT_DETAIL,
  ) {
    patchState({
      selectedProductDetail: {
        productDetail: null,
        productPath: null,
      },
    });
  }

  @Action(GET_ELIBRARY_INITIAL_DISPLAY)
  public getSearchList(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_ELIBRARY_INITIAL_DISPLAY,
  ) {
    return this.patchStructuredFolderContent(patchState, payload);
  }

  private patchStructuredFolderContent(patchState, payload) {
    return this.eLibraryService.getELibraryStructuredFolder(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            eLibraryContent: res,
          });
        }
      }),
    );
  }

  @Action(GET_ELIBRARY_CONTENT_BY_ID)
  public getElibraryContentById(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_ELIBRARY_CONTENT_BY_ID,
  ) {
    return this.eLibraryService.getELibraryContent(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            folderContent: res,
          });
        }
      }),
    );
  }

  @Action(SEARCH_ELIBRARY_CONTENT)
  public searchELibraryContent(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: SEARCH_ELIBRARY_CONTENT,
  ) {
    return this.eLibraryService.searchELibraryContent(payload).pipe(
      map((res) => {
        if (res.contents) {
          let data = res.contents.map((item) => {
            let language = item.customFields.find(
              (item) => item.name === "Language",
            );
            item.language = language.customValue.data[0];
            return item;
          });
          patchState({
            searchedELibrary: {
              data: data ? data : [],
              error: null,
            },
          });
        } else {
          patchState({
            searchedELibrary: {
              data: [],
              error: true,
            },
          });
        }
      }),
    );
  }

  @Action(GET_RECENT_UPLOAD)
  public getRecentUpload(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_RECENT_UPLOAD,
  ) {
    return this.eLibraryService.getRecentUpload(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            recentUpload: res.contents ? res.contents : null,
          });
        }
      }),
    );
  }

  @Action(RESET_SEARCH_ELIBRARY_CONTENT)
  public resetSearchELibraryContent({
    patchState,
  }: StateContext<ELibraryModel>) {
    patchState({
      searchedELibrary: {
        data: null,
        error: false,
      },
    });
  }

  @Action(GET_SINGLE_PRODUCT_DETAILS)
  public getSingleProductDetails(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: GET_SINGLE_PRODUCT_DETAILS,
  ) {
    return this.eLibraryService.getSingleProductDetails(payload).pipe(
      map((res) => {
        let data = res ? res : null;
        patchState({
          selectedProductDetail: data,
        });
      }),
    );
  }

  @Action(SET_PRODUCT_BREADCRUM)
  public setProductBreadCrum(
    { patchState }: StateContext<ELibraryModel>,
    { payload }: SET_PRODUCT_BREADCRUM,
  ) {
    patchState({
      productBreadCrum: payload,
    });
  }

  @Action(RESET_ELIBRARY_CONTENT_AND_RECENT_UPLOAD)
  public resetELibraryContent({ patchState }: StateContext<ELibraryModel>) {
    patchState({
      eLibraryContent: null,
      recentUpload: null,
    });
  }
}
